/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable react/prop-types, max-len */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddAttrPermissions.scss';

import ModalAlert from '../../../ModalAlert';
import { updateAttrsPermissions } from '../../../../../actions/district';

const fastStyleMargin = {
  marginTop: '7px',
};

class AddAttrPermissions extends React.Component {
  constructor(props) {
    super(props);
    const i = 0;
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      roleIndex: i,
      currentRole: this.unpackRole(this.props.district.roles[i]),
      currentLayer: '',
      changedAttrs: [],
    };
  }

  unpackRole = role => {
    const newRole = {
      nazwa: role.nazwa,
      layers: {},
    };
    role.attrs && role.attrs.forEach((v) => {
      const newAttr = {
        ...v,
      }
      if (v.attr.layer in newRole.layers) {
        newRole.layers[v.attr.layer].push(newAttr);
      } else {
        newRole.layers[v.attr.layer] = [];
        newRole.layers[v.attr.layer].push(newAttr);
      }
    });
    return newRole;
  }

  onConfirm = () => {}
  onChangeRole = (e) => {
    this.setState({
      isEdited: false,
      roleIndex: e.target.selectedIndex,
      currentRole: this.unpackRole(this.props.district.roles[e.target.selectedIndex]),
    });
  };

  dismissModal = () => this.setState({ showModal: false });
  dismissConfirm = () => this.setState({ showConfirm: false });

  saveAttrPermissions = () => {
  }

  checkIfChanged = (v) => {
    const attr = _.find(this.props.district.roles[this.state.roleIndex].attrs, (o) => (o.attr.nazwa === v.attr.nazwa && o.attr.layer === v.attr.layer));
    const isAttrEqual = _.isEqual(attr, v);
    const isAttrInList = _.find(this.state.changedAttrs, (o) => o.attr.nazwa === v.attr.nazwa)
    if (isAttrEqual) {
      if (isAttrInList) this.setState({
        changedAttrs: _.filter(this.state.changedAttrs, (o) => o.attr.nazwa !== v.attr.nazwa),
      });
    } else {
      if (!isAttrInList) this.setState({
        changedAttrs: this.state.changedAttrs.concat(v),
      });
    }
  }

  changeAttrPermissions = (e, v, i) => {
    const newAttrState = _.filter(this.state.currentRole.layers[this.state.currentLayer], (o) => {
      if (o.attr.nazwa === v.attr.nazwa) {
        const attr = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        o[attr] = value;
        return o;
      }
      return o;
    });
    this.setState({
      ...this.state.currentRole,
      layers: {
        [this.state.currentLayer]: newAttrState,
      },
    }, this.checkIfChanged(v));
  }

  onChangeLayer = (e) => {
    const curLayer = this.state.currentLayer;
    let oldState = {};
    this.setState({ currentLayer: e.target.value, changedAttrs: [] }, () => {
      this.props.district.roles[this.state.roleIndex].attrs.forEach((v) => {
        const newAttr = {
          ...v,
        }
        if (v.attr.layer in oldState) {
          oldState[v.attr.layer].push(newAttr);
        } else {
          oldState[v.attr.layer] = []
          oldState[v.attr.layer].push(newAttr);
        }
      });
      this.setState({
        currentRole: {
          ...this.state.currentRole,
          layers: oldState,
        },
      });
    });
  };

  checkMultipleAttrs = () => {

  }

  selectAll = () => {
    const newAttrState = _.filter(this.state.currentRole.layers[this.state.currentLayer], (o) => {
      o.r = true;
      o.w = true;
      o.d = true;
      return o;
    });
    this.setState({
      ...this.state.currentRole,
      layers: {
        [this.state.currentLayer]: newAttrState,
      },
    }, () => {
      let attrsNotEqual = [];
      for(let a in this.state.currentRole.layers[this.state.currentLayer]){
        let v = this.state.currentRole.layers[this.state.currentLayer][a];
        const attr = _.find(this.props.district.roles[this.state.roleIndex].attrs, (o) => (o.attr.nazwa === v.attr.nazwa && o.attr.layer === v.attr.layer));
        const isAttrEqual = _.isEqual(attr, v);
        if (!isAttrEqual) {
          attrsNotEqual.push(v);
        }
        this.setState({ changedAttrs: attrsNotEqual });
      }
    });
  }
  deselectAll = () => {
    const newAttrState = _.filter(this.state.currentRole.layers[this.state.currentLayer], (o) => {
      o.r = false;
      o.w = false;
      o.d = false;
      return o;
    });
    this.setState({
      ...this.state.currentRole,
      layers: {
        [this.state.currentLayer]: newAttrState,
      },
    }, () => {
      let attrsNotEqual = [];
      for(let a in this.state.currentRole.layers[this.state.currentLayer]){
        let v = this.state.currentRole.layers[this.state.currentLayer][a];
        const attr = _.find(this.props.district.roles[this.state.roleIndex].attrs, (o) => (o.attr.nazwa === v.attr.nazwa && o.attr.layer === v.attr.layer));
        const isAttrEqual = _.isEqual(attr, v);
        if (!isAttrEqual) {
          attrsNotEqual.push(v);
        }
        this.setState({ changedAttrs: attrsNotEqual });
      }
    });
  }
  save = () => {
    this.props.updateAttrsPermissions(this.props.district.prefix, this.state.changedAttrs, this.state.currentRole.nazwa)
    .then((resp) => {
      this.setState({ modalTitle: 'Status', modalBody: resp.message, showModal: true, changedAttrs: [] }, () => {
        const curLayer = this.state.currentLayer;
        let oldState = {};
        this.props.district.roles[this.state.roleIndex].attrs.forEach((v) => {
          const newAttr = {
            ...v,
          }
          if (v.attr.layer in oldState) {
            oldState[v.attr.layer].push(newAttr);
          } else {
            oldState[v.attr.layer] = [];
            oldState[v.attr.layer].push(newAttr);
          }
        });
        this.setState({
          currentRole: {
            ...this.state.currentRole,
            layers: oldState,
          },
        });
      });
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label htmlFor="selectRole" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
            <select
              name="selectRole"
              className="form-control"
              value={this.props.district.roles[this.state.roleIndex].nazwa}
              onChange={(e) => this.onChangeRole(e)}
            >
              {this.props.district.roles.map((v, i) => <option key={i} value={v.nazwa}>{v.nazwa}</option>)}
            </select>
            <select
              name="selectLayer"
              className="form-control"
              value={this.state.currentLayer}
              onChange={(e) => this.onChangeLayer(e)}
            >
              <option />
              {this.props.district.roles && this.state.roleIndex &&
                this.props.district.roles[this.state.roleIndex] &&
                this.props.district.roles[this.state.roleIndex].layers &&
                this.props.district.roles[this.state.roleIndex].layers.map((v, i) => {
                return v.r === true ? <option key={i} value={v.layer}>{v.layer}</option> : null;
              })}
            </select>
          </div>
        </div>
        <div className="row">
          <h2>Uprawnienia do atrybutów:</h2>
          <p>Modyfikuj lub dodaj uprawnienia do wybranych atrybutów.</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Nazwa atrybutu</th>
                <th>read</th>
                <th>write</th>
                <th>delete</th>
              </tr>
            </thead>
            <tbody>
              {this.state.currentLayer ?
                this.state.currentRole.layers[this.state.currentLayer].map((v, i) => {
                  return (
                    <tr key={i}>
                      <td>{v.attr.nazwa}</td>
                      <td><input name="r" type="checkbox" checked={v.r} onChange={(e) => this.changeAttrPermissions(e, v, i)} /></td>
                      <td><input name="w" type="checkbox" checked={v.w} onChange={(e) => this.changeAttrPermissions(e, v, i)} /></td>
                      <td><input name="d" type="checkbox" checked={v.d} onChange={(e) => this.changeAttrPermissions(e, v, i)} /></td>
                    </tr>
                  );
                })
               : null }
            </tbody>
          </table>
        </div>
        {this.state.currentLayer ? (
          <div className="row">
            <button type="button" className="btn btn-primary" onClick={() => this.selectAll()}>Zaznacz wszystko</button>
            <button type="button" className="btn btn-primary" onClick={() => this.deselectAll()}>Odznacz wszystko</button>
            {this.state.changedAttrs.length > 0 ? (
              <button type="button" className="btn btn-primary" onClick={() => this.save()}>Zapisz zmiany</button>
            ) : null }
          </div>
        ) : null}
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  updateAttrsPermissions,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddAttrPermissions));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddAttrPermissions/AddAttrPermissions.js